// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../members/MemberItem.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Invited Users List - MemberItem Style */

.invited-users-list {
  margin-top: var(--space-4);
  padding: var(--space-4);
  background: rgba(184, 71, 14, 0.05);
  border: 2px dashed var(--color-wood-600);
  border-radius: var(--radius-lg);
}

.invited-users-title {
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: var(--space-3);
}

.invited-users-items {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.invited-user-item {
  display: flex;
  align-items: center;
  padding: 0;
  border-radius: 12px;
  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);
  border: 2px solid var(--color-wood-800);
  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);
  transition: all 0.2s ease;
  overflow: visible;
}

.invited-user-item--reserved {
  border-color: var(--color-warning-600);
  background:
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 4px,
      rgba(249, 168, 37, 0.12) 4px,
      rgba(249, 168, 37, 0.12) 6px
    ),
    linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);
  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);
}

.invited-user-content {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: 10px 16px 10px 8px;
}

.invited-user-item .member-name a {
  color: var(--color-fire-600);
  text-decoration: none;
}

.invited-user-item .member-name a:hover {
  text-decoration: underline;
}

@media (max-width: 425px) {
  .invited-user-item {
    border-width: 1px;
    border-radius: 10px;
  }

  .invited-user-content {
    gap: 8px;
    padding: 8px 10px 8px 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/selection/InvitedUsersList.css"],"names":[],"mappings":"AAAA,0CAA0C;;AAG1C;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,mCAAmC;EACnC,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,6DAA6D;EAC7D,uCAAuC;EACvC,6CAA6C;EAC7C,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC;;;;;;;;qDAQmD;EACnD,6CAA6C;AAC/C;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,yBAAyB;EAC3B;AACF","sourcesContent":["/* Invited Users List - MemberItem Style */\n@import '../members/MemberItem.css';\n\n.invited-users-list {\n  margin-top: var(--space-4);\n  padding: var(--space-4);\n  background: rgba(184, 71, 14, 0.05);\n  border: 2px dashed var(--color-wood-600);\n  border-radius: var(--radius-lg);\n}\n\n.invited-users-title {\n  font-family: var(--font-heading);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-3);\n}\n\n.invited-users-items {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n}\n\n.invited-user-item {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #e8dcc8 0%, #d4c4a8 100%);\n  border: 2px solid var(--color-wood-800);\n  box-shadow: 0 2px 8px rgba(109, 76, 41, 0.35);\n  transition: all 0.2s ease;\n  overflow: visible;\n}\n\n.invited-user-item--reserved {\n  border-color: var(--color-warning-600);\n  background:\n    repeating-linear-gradient(\n      -45deg,\n      transparent,\n      transparent 4px,\n      rgba(249, 168, 37, 0.12) 4px,\n      rgba(249, 168, 37, 0.12) 6px\n    ),\n    linear-gradient(135deg, #fdf8ed 0%, #fef5e7 100%);\n  box-shadow: 0 2px 8px rgba(212, 167, 74, 0.2);\n}\n\n.invited-user-content {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  padding: 10px 16px 10px 8px;\n}\n\n.invited-user-item .member-name a {\n  color: var(--color-fire-600);\n  text-decoration: none;\n}\n\n.invited-user-item .member-name a:hover {\n  text-decoration: underline;\n}\n\n@media (max-width: 425px) {\n  .invited-user-item {\n    border-width: 1px;\n    border-radius: 10px;\n  }\n\n  .invited-user-content {\n    gap: 8px;\n    padding: 8px 10px 8px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
